// @flow
import React from 'react';

type Props = {
    firstColumn: React.ReactElement,
    secondColumn: React.ReactElement,
    thirdColumn: React.ReactElement,
    rowStyles?: {}
};

const NotificationSettingsRowTemplate = ({
    firstColumn,
    secondColumn,
    thirdColumn,
    rowStyles
}: Props) => {
    return (
        <div className="settings-row" style={rowStyles}>
            <div className="description-column">{firstColumn}</div>
            <div className="checkbox-column">{secondColumn}</div>
            <div className="checkbox-column">{thirdColumn}</div>
        </div>
    );
};

NotificationSettingsRowTemplate.defaultProps = {
    rowStyles: {}
};

export default NotificationSettingsRowTemplate;
